import { Component, OnInit } from "@angular/core";
import { ProjectService } from "../services/project.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CommentService } from "../services/comment.service";
import { Subscription } from "rxjs";
import { environment } from "../../environments/environment";

@Component({
  selector: "app-confirm",
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.css"]
})
export class ConfirmComponent implements OnInit {
  project: any;
  projectSubscription: Subscription;
  comment: any;
  commentSubscription: Subscription;
  environment: any;

  constructor(
    private projectService: ProjectService,
    private router: Router,
    private route: ActivatedRoute,
    private commentService: CommentService
  ) {
    // for observing changes to the current project
    this.projectSubscription = projectService.currentProject$.subscribe(
      project => {
        this.project = project;
      }
    );

    // for observing changes to the current comment
    this.commentSubscription = commentService.currentCommentResponse$.subscribe(
      comment => {
        this.comment = comment;
      }
    );
  }

  ngOnInit() {
    this.environment = environment;
    this.comment = this.commentService.currentCommentResponseValue;
    console.log(this.comment);
  }

  ngOnDestory() {
    this.projectSubscription.unsubscribe();
  }

  handleExternalProjectTap() {
    if (environment.serverUrl) {
      const win = window.open(environment.serverUrl, "_blank");
      win.focus();
    }
  }

  handleNewCommentTap() {
    const newRoute = `${this.route.snapshot.paramMap.get("id")}/form`;
    this.router.navigateByUrl(newRoute);
  }
}



// WEBPACK FOOTER //
// ./src/app/confirm/confirm.component.ts